import classes from "../SeedLister.module.css"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

const NameplateInit = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            <h2>{t("misc:SeedListing.NameplateHeadline")}</h2>
            <p>
                <NavLink to="/profile" end>
                    {t("misc:SeedListing.NameplateFinderIntroduction")}
                </NavLink>
            </p>
        </div>
    )
}

export default NameplateInit
